module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"frontmatter":{"title":"UX for Lean Startups","path":"/blog/libros/ux-for-lean-startups"}}}]}},"pathContext":{"tag":"ux"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/blog-etiquetas-ux.json
// module id = 341
// module chunks = 12836020992764